import { NotEligibleScreen } from '@/components/NotEligibleScreen';

export default function NotEligible() {
  return <NotEligibleScreen />;
}
